"use strict";
var local_storage_module_1 = require('./local-storage.module');
exports.LocalStorageModule = local_storage_module_1.LocalStorageModule;
var local_storage_service_1 = require('./local-storage.service');
exports.LocalStorageService = local_storage_service_1.LocalStorageService;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/~/angular-2-local-storage/dist/index.js
// module id = ../../../../angular-2-local-storage/dist/index.js
// module chunks = 3